import React from 'react'

// Providers
import { SignUpProvider } from 'src/features/SignUp/SignUp/SignUpContext'
import { WizardProvider } from 'src/Components/shared/WizardContext'

// Constants
import { SIGN_UP_STEPS, SIGN_UP_STEPS_ORDERED } from 'src/constants/signUp'

// Components
import Body from './Body'

const SignUp = props => (
  <WizardProvider
    steps={SIGN_UP_STEPS_ORDERED}
    initialStep={SIGN_UP_STEPS.USER_EMAIL}
  >
    <SignUpProvider>
      <Body {...props} />
    </SignUpProvider>
  </WizardProvider>
)

export default SignUp
